import { getField, updateField } from 'vuex-map-fields'
import {
  exportXlsPosts,
  formatFilters,
  setPostPublishedState
} from '@/services/posts'

import store from '@/store'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import { $t } from '@/i18n'
import { Message } from 'element-ui'

const getDefaultFilter = () => ({
  page: 1,
  offset: 0,
  limit: 10,
  sort: '-DC',
  advanced: false, // Panneau recherche avancé ouvert
  search: '', // Recherche
  type: null, // Type de logement
  sellType: null, // Vente | Location
  published: null, // Visibles / désactivées
  priceGt: null,
  priceLt: null,
  dateCreationGt: null,
  dateCreationLt: null,
  objectTypes: [],
  annoncesActivees: true,
  annoncesDesactivees: null,
  annoncesSupprimees: null,
  annoncesModeles: null,
  annonceParente: null,
  mandates: [], // Type de mandat
  surfaceGt: null,
  surfaceLt: null,
  stock: null,
  offerTypes: [],
  typeObjets: [],
  withoutPictures: null,
  preset: 'enable',
  annoncesDiffusees: null,
  contact: '',
  creationProgramme: null
})

const getPresetFilters = () => ({
  preset: 'enable'
})

export default {
  namespaced: true,
  state: {
    fetchModeles: false,
    annonceParente: null,
    annoncesContacts: {}, // dans le cas ou l'on crée ou édit une annonce
    bienVenduModaleArchiveNOk: false,
    bienVenduModaleArchiveOk: false,
    bienVendus: true,
    contacts: [],
    contactsAnnonces: null,
    currentId: null,
    currentLandId: null,
    currentModelId: null,
    currentProgramId: null,
    deleteId: null,
    filter: getDefaultFilter(),
    loadingCMIcreatePost: false,
    loadingStatus: false,
    modalCreationLot: false,
    modalCmisteModelDisabled: true,
    modalConfirmedChangeContactList: false,
    modalConfirmedDeleteList: false,
    modalDelete: false,
    modalDuplicate: false,
    modalShowModels: false,
    modalUseModel: false,
    popupBiensVendus: false,
    post: { code_postal_reel: 30 },
    programsModalPromoter: null,
    selectTypeObjetModele: null,
    referenceDuplication: null,
    refreshProgramme: false,
    results: {
      total: -1,
      list: []
    },
    selection: [],
    tabs: []
  },
  getters: {
    getPostField (state) {
      return getField(state.post)
    },
    getPopupBienVendus (state) {
      return state.popupBiensVendus
    },
    getModalDelete (state) {
      return state.modalDelete
    },
    getModalConfirmedDeleteList (state) {
      return state.modalConfirmedDeleteList
    },
    getBienVenduModaleArchiveNOk (state) {
      return state.bienVenduModaleArchiveNOk
    },
    getRefreshProgramme (state) {
      return state.refreshProgramme
    },
    getLoadingStatus (state) {
      return state.loadingStatus
    },
    getTabs (state) {
      return state.tabs
    },
    getAnnonceParente (state) {
      return state.annonceParente
    },
    getResults (state) {
      return state.results
    },
    getList (state) {
      return state.results.list
    },
    getLimit (state) {
      return state.filter.limit
    },
    getSort (state) {
      return state.filter.sort
    },
    getOfferType (state) {
      return state.post.typeOffre
    },
    getSearch (state) {
      return state.filter.search
    },
    getTotal (state) {
      return state.results.total
    },
    getFilters (state) {
      return state.filter
    },
    getPage (state) {
      return state.filter.page
    },
    annonceParente: state => state.annonceParente,
    annoncesContacts: state => state.annoncesContacts,
    bienVenduModaleArchiveNOk: state => state.bienVenduModaleArchiveNOk,
    bienVenduModaleArchiveOk: state => state.bienVenduModaleArchiveOk,
    bienVendus: state => state.bienVendus,
    contacts: state => state.contacts,
    contactsAnnonces: state => state.contactsAnnonces,
    currentId: state => state.currentId,
    currentLandId: state => state.currentLandId,
    currentModelId: state => state.currentModelId,
    currentProgramId: state => state.currentProgramId,
    deleteId: state => state.deleteId,
    fetchModeles: state => state.fetchModeles,
    filter: state => state.filter,
    limit: state => state.filter.limit,
    list: state => state.results.list,
    loadingCMIcreatePost: state => state.loadingCMIcreatePost,
    loadingStatus: state => state.loadingStatus,
    modalCmisteModelDisabled: state => state.modalCmisteModelDisabled,
    modalCreationLot: state => state.modalCreationLot,
    modalConfirmedChangeContactList: state => state.modalConfirmedChangeContactList,
    modalConfirmedDeleteList: state => state.modalConfirmedDeleteList,
    modalDelete: state => state.modalDelete,
    modalDuplicate: state => state.modalDuplicate,
    modalShowModels: state => state.modalShowModels,
    modalUseModel: state => state.modalUseModel,
    page: state => state.filter.page,
    popupBiensVendus: state => state.popupBiensVendus,
    post: state => state.post,
    programsModalPromoter: state => state.programsModalPromoter,
    referenceDuplication: state => state.referenceDuplication,
    refreshProgramme: state => state.refreshProgramme,
    results: state => state.results,
    selection: state => state.selection,
    selectTypeObjetModele: state => state.selectTypeObjetModele,
    tabs: state => state.tabs,
    total: state => state.results.total,
    //  Getter pour les filtres sauvegardés
    getSavedFilters: state => state.filter
  },
  mutations: {
    RESET_FILTER (state) {
      state.filter = getDefaultFilter()
    },
    //  Chargement des filtres sauvegardés
    LOAD_SAVED_FILTERS (state, savedFilters) {
      
      if (savedFilters) {
        // Merger avec les filtres par défaut pour éviter les champs manquants
        const defaultFilters = getDefaultFilter()
        
        state.filter = {
          ...defaultFilters,
          ...savedFilters, // Appliquer les filtres sauvegardés
          page: 1 // Toujours repartir à la page 1
        }
        
        //  Réinitialiser explicitement les champs range s'ils ne sont pas dans savedFilters
        if (!savedFilters.hasOwnProperty('surfaceGt')) {
          state.filter.surfaceGt = null
        }
        if (!savedFilters.hasOwnProperty('surfaceLt')) {
          state.filter.surfaceLt = null
        }
        if (!savedFilters.hasOwnProperty('priceGt')) {
          state.filter.priceGt = null
        }
        if (!savedFilters.hasOwnProperty('priceLt')) {
          state.filter.priceLt = null
        }
        
      }
    },
    //  Sauvegarde des filtres
    SAVE_FILTERS (state, filters) {
      // Merger les nouveaux filtres avec l'état actuel
      state.filter = {
        ...state.filter,
        ...filters,
        page: 1 // Remettre à la page 1 lors d'un changement de filtre
      }
    },
    SET_ANNONCE_PARENTE (state, annonceParente) {
      state.filter.annonceParente = annonceParente
      state.annonceParente = annonceParente
      store.commit('posts/setAnnonceParente', annonceParente)
    },
    SET_LIST (state, list) {
      state.results.list = list
    },
    SET_ANNONCES_CONTACTS (state, annoncesContacts) {
      state.annoncesContacts = annoncesContacts
    },
    SET_ANNONCES_MODELES (state, annoncesModeles) {
      state.filter.annoncesModeles = annoncesModeles
    },
    SET_BIEN_VENDU_MODALE_ARCHIVE_N_OK (state, bienVenduModaleArchiveNOk) {
      state.bienVenduModaleArchiveNOk = bienVenduModaleArchiveNOk
    },
    SET_BIEN_VENDU_MODALE_ARCHIVE_OK (state, bienVenduModaleArchiveOk) {
      state.bienVenduModaleArchiveOk = bienVenduModaleArchiveOk
    },
    SET_CONTACTS_ANNONCES (state, contactsAnnonces) {
      state.contactsAnnonces = contactsAnnonces
    },
    SET_CREATION_PROGRAMME (state, creationProgramme) {
      state.filter.creationProgramme = creationProgramme
    },
    SET_BIEN_VENDUS (state, bienVendus) {
      state.bienVendus = bienVendus
    },
    SET_FETCH_MODELES (state, fetchModeles) {
      state.fetchModeles = fetchModeles
    },
    SET_CONTACTS (state, contacts) {
      state.contacts = contacts
    },
    SET_CURRENT_ID (state, currentId) {
      state.currentId = currentId
    },
    SET_CURRENT_LAND_ID (state, currentLandId) {
      state.currentLandId = currentLandId
    },
    SET_CURRENT_MODEL_ID (state, currentModelId) {
      state.currentModelId = currentModelId
    },
    SET_CURRENT_PROGRAM_ID (state, currentProgramId) {
      state.currentProgramId = currentProgramId
    },
    SET_DELETE_ID (state, deleteId) {
      state.deleteId = deleteId
    },
    SET_FILTER (state, filter) {
      state.filter = filter
    },
    SET_LIMIT (state, limit) {
      state.filter.limit = limit
    },
    SET_OBJECT_TYPE (state, payload) {
      state.filter.typeObjets = payload
    },
    SET_LOADING_CMI_CREATE_POST (state, loadingCMIcreatePost) {
      state.loadingCMIcreatePost = loadingCMIcreatePost
    },
    SET_LOADING_STATUS (state, loadingStatus) {
      state.loadingStatus = loadingStatus
    },
    SET_MODAL_CMISTE_MODEL_DISABLED (state, modalCmisteModelDisabled) {
      state.modalCmisteModelDisabled = modalCmisteModelDisabled
    },
    SET_MODAL_CONFIRMED_CHANGE_CONTACT_LIST (state, modalConfirmedChangeContactList) {
      state.modalConfirmedChangeContactList = modalConfirmedChangeContactList
    },
    SET_MODAL_CONFIRMED_DELETE_LIST (state, modalConfirmedDeleteList) {
      state.modalConfirmedDeleteList = modalConfirmedDeleteList
    },
    SET_MODAL_CREATION_LOT (state, modalCreationLot) {
      state.modalCreationLot = modalCreationLot
    },
    SET_MODAL_DELETE (state, modalDelete) {
      state.modalDelete = modalDelete
    },
    SET_MODAL_DUPLICATE (state, modalDuplicate) {
      state.modalDuplicate = modalDuplicate
    },
    SET_MODAL_SHOW_MODELS (state, modalShowModels) {
      state.modalShowModels = modalShowModels
    },
    SET_MODAL_USE_MODEL (state, modalUseModel) {
      state.modalUseModel = modalUseModel
    },
    SET_PAGE (state, page) {
      state.filter.page = page
    },
    SET_POPUP_BIENS_VENDUS (state, popupBiensVendus) {
      state.popupBiensVendus = popupBiensVendus
    },
    SET_POST (state, post) {
      state.post = post
    },
    SET_PRESET (state, preset) {
      state.filter.preset = preset
    },
    SET_PROGRAMS_MODAL_PROMOTER (state, programsModalPromoter) {
      state.programsModalPromoter = programsModalPromoter
    },
    SET_REFERENCE_DUPLICATION (state, referenceDuplication) {
      state.referenceDuplication = referenceDuplication
    },
    SET_REFRESH_PROGRAMME (state, refreshProgramme) {
      state.refreshProgramme = refreshProgramme
    },
    SET_RESULTS (state, results) {
      state.results = results
    },
    SET_SELECTION (state, selection) {
      state.selection = selection
    },
    SET_SELECT_TYPE_OBJET_MODELE (state, selectTypeObjetModele) {
      state.selectTypeObjetModele = selectTypeObjetModele
    },
    SET_TABS (state, tabs) {
      state.tabs = tabs
    },
    SET_TOTAL (state, total) {
      state.results.total = total
    },
    updatePostField (state, field) {
      updateField(state.post, field)
    },
    setPopupBiensVendus (state, popupBiensVendus) {
      state.popupBiensVendus = popupBiensVendus
    },
    setPost (state, post) {
      state.post = post
    },
    setTabs (state, tabs) {
      state.tabs = tabs
    },
    setObjectType (state, objectType) {
      state.post.typeObjet = objectType
    },
    setLoadingStatus (state, loadingStatus) {
      state.loadingStatus = loadingStatus
    },
    setOfferType (state, offerType) {
      state.post.typeOffre = offerType
    },
    setAnnonceParente (state, annonceParente) {
      state.annonceParente = annonceParente
    },
    setPage (state, page) {
      state.filter = { ...state.filter, page }
    },
    setModalDelete (state, modalDelete) {
      state.modalDelete = modalDelete
    },
    setModalConfirmedDeleteList (state, modalConfirmedDeleteList) {
      state.modalConfirmedDeleteList = modalConfirmedDeleteList
    },
    setLimit (state, limit) {
      state.filter = { ...state.filter, limit, page: 1 }
    },
    setOffset (state, offset) {
      state.filter = { ...state.filter, offset, page: 1 }
    },
    setSort (state, sort) {
      state.filter = { ...state.filter, sort, page: 1 }
    },
    setSearch (state, search) {
      state.filter = { ...state.filter, search, page: 1 }
    },
    addFilter (state, filter) {
      // Fusionner les filtres
      state.filter = { ...state.filter, ...filter }
      
      // Supprimer les clés marquées comme undefined (pour nettoyer les filtres désépinglés)
      Object.keys(state.filter).forEach(key => {
        if (state.filter[key] === undefined) {
          delete state.filter[key]
        }
      })
    },
    replaceFilter (state, filter) {
      // Remplacer complètement le filtre sans getDefaultFilter()
      //  Garder les champs système ET le contexte annonceParente
      state.filter = {
        page: state.filter.page || 1,
        offset: state.filter.offset || 0,
        limit: state.filter.limit || 10,
        sort: state.filter.sort || '-DC',
        advanced: state.filter.advanced || false,
        annonceParente: state.filter.annonceParente, //  Préserver le contexte lots/programmes
        ...filter
      }
    },
    setFilter (state, filter) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...filter
      }
    },
    setFilterAdvanced (state, filter) {
      state.filter = {
        ...state.filter,
        advanced: state.filter.advanced,
        ...filter
      }
    },
    resetFilter (state) {
      state.filter = getDefaultFilter()
      store.commit('posts/setObjectTypeFilter', [])
      state.results = { total: -1, list: [] }
    },
    resetPresetFilters (state) {
      state.filter = {
        ...getDefaultFilter(),
        advanced: state.filter.advanced,
        ...getPresetFilters()
      }
    },
    setResults (state, results) {
      state.results = results
    },
    setBienVenduModaleArchiveNOk (state, bienVenduModaleArchiveNOk) {
      state.bienVenduModaleArchiveNOk = bienVenduModaleArchiveNOk
    },
    setBienVenduModaleArchiveOk (state, bienVenduModaleArchiveOk) {
      state.bienVenduModaleArchiveOk = bienVenduModaleArchiveOk
    },
    setRefreshProgramme (state, refreshProgramme) {
      state.refreshProgramme = refreshProgramme
    }
  },
  actions: {
    async switchPublishedState ({ commit, dispatch }, { id, selectedIds, isAffichageReduit }) {
      try {
        commit('SET_LOADING_STATUS', true)

        const changedState = await setPostPublishedState(
          selectedIds,
          id,
          'SAISIE_IMMO'
        )

        if (changedState && changedState.type === 'error') {
          return {
            type: 'error',
            message: $t('error.found')
          }
        }

        // Attendre 1.5s avant de recharger la liste
        await new Promise(resolve => setTimeout(resolve, 1500))
        await dispatch('loadPosts')

        if (isAffichageReduit) {
          commit('SET_SELECTION', [])
        }

        return { type: 'success' }
      } catch (error) {
        console.error('Error switching published state:', error)
        return {
          type: 'error',
          message: $t('error.found')
        }
      } finally {
        commit('SET_LOADING_STATUS', false)
        dispatch('loadPosts')
      }
    },
    async exportPosts ({ commit, state }, selectedIds) {
      try {
        commit('SET_LOADING_STATUS', true)
        const formattedSelectedIds = selectedIds.map(id => ({ id }))
        let strSelectedIds = null
        let i = 0
        selectedIds.forEach(function (idSelected) {
          if (i === 0) {
            strSelectedIds = idSelected
          } else {
            strSelectedIds = strSelectedIds + ',' + idSelected
          }
          i++
        })
        const filters = {
          filter: state.filter,
          selectedIds: formattedSelectedIds,
          isTemplate: false,
          filename: $t('posts.list.filenameExportAds')
        }
        const response = await exportXlsPosts(filters, strSelectedIds, false, 'ANNONCE_')

        Message({ message: $t('layouts.exportSuccess'), type: 'success' })
      } catch (error) {
        console.error('Error exporting posts:', error)
        Message({
          type: 'error',
          message: $t('error.export')
        })
        return { type: 'error' }
      } finally {
        commit('SET_LOADING_STATUS', false)
      }
    },
    async loadPosts (context, filtersOrOptions) {
      //  Support des options pour forcer l'exécution
      let filters = filtersOrOptions
      let options = {}
      
      // Si c'est un objet avec une propriété 'force', c'est un objet d'options
      if (filtersOrOptions && typeof filtersOrOptions === 'object' && filtersOrOptions.hasOwnProperty('force')) {
        filters = filtersOrOptions.filters
        options = filtersOrOptions
      }
      
      console.log('loadPosts action déclenchée, loadingStatus:', context.state.loadingStatus, 'force:', options.force)
      
      //  MODIFIÉ : Permettre de forcer l'exécution même si loadingStatus = true
      if (context.state.loadingStatus && !options.force) {
        console.log('loadPosts bloqué car loadingStatus = true, retour immédiat')
        return
      }

      //  MODIFIÉ : Ne pas afficher le loader si silent (pour les cascaders)
      // Ne pas réactiver le loader s'il est déjà actif (évite les conflits)
      if (!context.state.loadingStatus && !options.silent) {
        context.commit('SET_LOADING_STATUS', true)
      }
      const qs = require('qs')

      const sitimmoUser = store.getters.getSitimmoUser
      let searchFilters = null

      if (filters) {
        searchFilters = filters
      } else {
        searchFilters = context.getters.getFilters
      }
      const params = {
        params: formatFilters(
          searchFilters,
          null,
          null,
          null,
          sitimmoUser.univers,
          null
        ),
        paramsSerializer: function (params) {
          return qs.stringify(params, { encode: false })
        }
      }
      const url =
        '/annonce?champsRechercheLibre[]=ville&champsRechercheLibre[]=titre&champsRechercheLibre[]=reference'

      HTTP_HYPER_ESPACE_BACKEND.get(url, params)
        .then(response => {
          context.commit('SET_RESULTS', {
            total: response.data.total_items,
            list: response.data._embedded.annonce
          })
        })
        .catch(error => {
          console.log(error)
          context.commit('SET_LOADING_STATUS', false)
        })
        .finally(function () {
          context.dispatch('mergeContacts')
          context.commit('SET_LOADING_STATUS', false)
        })
    },
    mergeContacts (context, payload) {
      try {
        if (context.getters.contactsAnnonces) {
          context.commit('SET_LOADING_STATUS', true)
          const listeAnnonces = context.getters.getList
          let tempAnnonces = []
          const contacts = Object.entries(context.getters.contactsAnnonces)
          listeAnnonces.forEach(function (item) {
            const index = contacts.find(p => p[0] === item.reference)
            if (index) {
              item.nbContactsMailtracking = index[1]
            } else {
              item.nbContactsMailtracking = 0
            }
            tempAnnonces.push(item)
          })
          context.commit('SET_LIST', tempAnnonces)
        }
      } catch {
        Message($t('message.error'))
      } finally {
        context.commit('SET_LOADING_STATUS', false)
      }
    }
  }
}
